import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const NaturalFacialPractice = lazyWithPreload(
  () => import('./NaturalFacialPractice'),
)
